import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { ViewerStateTypes } from '../../nextray/States/State';
import { BaseComponent } from '../shared';


/**
* Component for viewer tool.
*/
@Component({
	selector: 'viewer',
	templateUrl: './viewer.component.html',
	imports: [
		FormsModule,
		ReactiveFormsModule
	],
	changeDetection: ChangeDetectionStrategy.Eager,
})
export class ViewerComponent extends BaseComponent implements OnInit {

	diagonalForm?: FormGroup;
	rangeErrorMsg = '';

	private readonly minValue = 7;
	private readonly maxValue = 100;
	private readonly onlyOneDecimal = /^\d+(\.\d?)?$/;


	ngOnInit(): void {
		this.initForm();
	}

	private initForm(): void {
		this.diagonalForm = new FormGroup({
			diagonal: new FormControl<number | null>(null, [Validators.required, Validators.pattern(this.onlyOneDecimal), Validators.min(this.minValue), Validators.max(this.maxValue)])
		});
		this.rangeErrorMsg = (this.labels().VALIDATION_MESSAGE_RANGE_NUMBER as string).replace('{{1}}', this.minValue.toString()).replace('{{2}}', this.maxValue.toString());
	}

	/**
	* Get diagonal form control.
	*/
	get diagonalCtrl(): FormControl<number | null> { return this.diagonalForm!.controls['diagonal'] as FormControl<number | null>; }

	/**
	* Set proximal setting.
	*/
	setProximal(): void {
		this.canvasSrv.dispatch('setViewer', ViewerStateTypes.proximal);
		this.setRealisticZoom();
	}

	/**
	* Set osteotomy setting.
	*/
	setOsteotomy(): void {
		this.canvasSrv.dispatch('setViewer', ViewerStateTypes.osteotomy);
		this.setRealisticZoom();
	}

	/**
	* Set distal setting.
	*/
	setDistal(): void {
		this.canvasSrv.dispatch('setViewer', ViewerStateTypes.distal);
		this.setRealisticZoom();
	}

	/**
	* Fit to view.
	*/
	fitToView(): void {
		this.canvasSrv.dispatch('setViewer', ViewerStateTypes.fitToView);
	}

	/**
	* Set realistic zoom.
	*/
	setRealisticZoom(): void {
		if (!this.diagonalCtrl.invalid) {
			const diagonal = this.diagonalCtrl.value ?? undefined;
			this.canvasSrv.dispatch('setRealisticZoom', diagonal);
		}
	}

	/**
	* Close the viewer.
	*/
	closeViewer(): void {
		this.canvasSrv.dispatch('closeViewer');
		this.canvasSrv.saveState();
	}

}
